<script setup>
import { VForm } from 'vuetify/components'
import topImage from '@/assets/images/pages/fineDining1.webp'

import logoLargeLight from '@/assets/logo-large-light.svg'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import {useRoute} from "vue-router"
import {useAppAbility} from "@/plugins/casl/useAppAbility"
import axios from "@axios"
import {
  emailValidator,
  requiredValidator
} from '@validators'
import { safeRedirectPath } from '@/utils/safeRedirect'


import {useUsersStore,useUserGroupsStore} from "@/stores"
import moment from "moment"
import HomeOverview from "@core/components/HomeOverview.vue"


const route = useRoute()
const router = useRouter()
console.log('route', route)
console.log('route', route.params.all[0])


let thePublicId = route.params.all[0]

thePublicId = thePublicId.toLowerCase()

const userGroupsStore = useUserGroupsStore()
let guestUserGroup;
({ guestUserGroup } = storeToRefs(userGroupsStore))
userGroupsStore.getGuestUserGroup(thePublicId, "enterprise")

const usersStore = useUsersStore()
let loginDialogVerificationType = null;
({loginDialogVerificationType} = storeToRefs(usersStore))

onMounted(() => {
  loginDialogVerificationType.value = 'activate'
})

const refVForm = ref(null)
const email = ref(route?.query?.email || '')
console.log('email', email)
const password = ref('')
const termsAccepted = ref(true)

// Ability
const ability = useAppAbility()

// Form Errors
const errors = ref({
  email: undefined,
  password: undefined,
  termsAccepted: undefined
})
const register = () => {
  axios.post('/auth/register/' + thePublicId, {
    email: email.value,
    password: password.value,
    termsAccepted: termsAccepted.value,
  }).then(r => {
    const {userData, userAbilities, jwt} = r.data
    localStorage.setItem('userAbilities', JSON.stringify(userAbilities))

    //ability.update(userAbilities)
    localStorage.setItem('userData', JSON.stringify(userData))
    localStorage.setItem('accessToken', JSON.stringify(jwt))
    localStorage.setItem('jwt', JSON.stringify(jwt))
    // C9: validate ?to= against an allowlist before the post-login reload.
    location.href = safeRedirectPath(route.query.to) || '/m/'

    return null
  }).catch(e => {
    const {errors: formErrors} = e.response.data
    errors.value = formErrors
    console.error(e.response.data)
  })
}
const isPasswordVisible = ref(false)
const onSubmit = () => {
  if (errors.value) {
    errors.value = {}
  }

  refVForm.value?.validate().then(({valid: isValid}) => {
    if (isValid)
      register()
  })
}
</script>

<template>
  <div v-if="guestUserGroup">
    <section class="home-masthead">
      <div class="content-wrapper">
        <div class="masthead-content">
          <HomeMasthead 
            :join-page="true" 
            :verified-element="true" 
            :book-btn="false" 
            :learn-more-first="true" 
            activate-text="Request Access"
            :for-clients="guestUserGroup.joinMessage || `${guestUserGroup.name} Group Membership`" 
            :ios-app-available="false"
            :show-restaurants-link="false"
          />
        </div>
      </div>
    </section>

    <HomeMainContent />
  </div>
</template>

<style lang="scss" scoped>
@use "@core/scss/pages/misc.scss";
.masthead-content {
  padding: 0 1rem;
  margin: 1rem 0;
}
.v-text-field .v-field--active input {
  opacity: 1;
}
input[type="text"]
{
  background: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
